import { Output, EventEmitter, OnInit, Input } from '@angular/core';

export class E5coreUiSearchMenuBase implements OnInit {

  @Output() search = new EventEmitter() ;
  @Output() reset = new EventEmitter() ;
  @Output() refresh = new EventEmitter() ;

  onSearch() {
    this.search.emit() ;
  }

  onReset() {
    this.reset.emit() ;
  }

  onRefresh() {
    this.refresh.emit() ;
  }

  ngOnInit(): void {
  }
}
